<div>
  <!-- <ion-toolbar color="primary"> -->
  <h4>
    @if (!viewOnly) {
    <p>Set location radius</p>
    } @if (viewOnly) {
    <p>View location</p>
    }
  </h4>
  <!-- </ion-toolbar> -->
</div>

<div class="content">
  <huge-row>
    <mat-col class="text" size="4"
      >Terminal ID: <b>{{ terminalid }}</b></mat-col
    >
    <mat-col class="text" size="4"
      >IMEI: <b>{{ imei }}</b></mat-col
    >
  </huge-row>
  <huge-row>
    <mat-col class="text" size="4"
      >Coordinates: <b>{{ lat }} , {{ lng }}</b></mat-col
    >
    <mat-col class="text" size="4"
      >Ring fence: <b>{{ rangeValue.value }} Km</b></mat-col
    >
  </huge-row>
  <huge-row [hidden]="description == null || description.length == 0">
    <huge-row class="text">
      <mat-col><b>Description:</b></mat-col>
    </huge-row>
    <huge-row class="text">
      <mat-col>{{ description }}</mat-col>
    </huge-row>
  </huge-row>
  @if (previousLocationUnknown) {
  <huge-row>
    <mat-col class="text-align-center mat-align-items-center">
      <mat-icon color="danger" style="vertical-align: middle">warning</mat-icon>
      <p color="danger" style="vertical-align: middle">Device was previously at an unknown tower</p>
    </mat-col>
  </huge-row>
  }
  <huge-row>
    <mat-col>
      <div #map id="map"></div>
      <div class="my-legend">
        <div class="legend-scale">
          <ul class="legend-labels">
            <li><span style="background: #008000"></span>Accepted Tower Location</li>
            @if (!viewOnly) {
            <li><span style="background: #ff0000"></span>Current Tower Location</li>
            } @if (!viewOnly) {
            <li><span style="background: #da70d6"></span>Previous Tower Location</li>
            }
          </ul>
        </div>
      </div>
    </mat-col>
  </huge-row>

  @if (!viewOnly) {
  <mat-list-item lines="none">
    <mat-slider
      [(ngModel)]="rangeValue.value"
      (ionChange)="changeRadius($event)"
      value="rangeValue.value"
      debounce="5"
      min="0"
      max="100"
      step="1"
      pin="true"
      class="mat-padding-none"
    >
      <mat-label slot="start">0</mat-label>
      <mat-label slot="end">100</mat-label>
    </mat-slider>
  </mat-list-item>
  } @if (!viewOnly) {
  <div class="btn-section">
    <button class="btn secondary-btn" expand="full" (click)="closeModal(null)">CANCEL</button>
    <button class="btn primary-btn" expand="full" (click)="setRingFence()">SAVE</button>
  </div>
  } @if (viewOnly) {
  <div class="btn-section">
    <button class="btn primary-btn" expand="full" (click)="closeModal(null)">Close</button>
  </div>
  }
</div>
